import React from 'react'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link} from 'react-router-dom'
import Style from './AccardionItem.module.scss'
import { Badge } from 'antd'
const AccardionItem = (props) => {

  return (
    <div className={Style.component}>
      {
        props.accardonItem.map(val=>{
          return( 
            <Link key={val.id} to={val.link} className={val.active===true?Style.contentChildClicked:Style.contentChild}>
              <FontAwesomeIcon icon={faCircle} className={Style.icon}/>
              <p className={Style.contentText}>{val.title}</p>
              {
                val.count?<Badge count={val.count}/>:null
              }
            </Link>
          ) 
        })
      }
    </div>
  )
}

export default AccardionItem